<div hsg-modal-body>
  Another user has already saved this staffing plan. Please refresh the page and try again.
</div>
<div hsg-modal-footer>
  <button class="primary" (click)="reloadPage()" [hsgModalClose]="true">OK</button>
</div>